/* eslint-disable */
import Oidc from 'oidc-client';
import 'babel-polyfill';

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.INFO;

const ONELOGIN_CLIENT_ID = process.env.VUE_APP_ONE_LOGIN_CLIENT_ID;
const ONELOGIN_SUBDOMAIN = process.env.VUE_APP_ONE_LOGIN_SUBDOMAIN;

var settings = {
  authority: 'https://' + ONELOGIN_SUBDOMAIN + '.onelogin.com/oidc/2',    
  client_id: ONELOGIN_CLIENT_ID,
  redirect_uri: process.env.VUE_APP_ONE_LOGIN_REDIRECT_URI,
  response_type: 'code',
  scope: 'openid profile groups phone params',
  filterProtocolClaims: true,
  loadUserInfo: true,
  automaticSilentRenew: true,
};

var mgr = new Oidc.UserManager(settings);

mgr.events.addUserLoaded(function (user) {  
  // console.log('New User Loaded：', arguments);
  // console.log('Access_token: ', user.access_token)
});

mgr.events.addAccessTokenExpiring(function () {
  // console.log('AccessToken Expiring：', arguments);
});

mgr.events.addAccessTokenExpired(function () {
  // console.log('AccessToken Expired：', arguments);  
  // alert('Session expired. Going out!');
  mgr.signoutRedirect().then(function (resp) {
    // console.log('signed out', resp);
  }).catch(function (err) {
    // console.log(err)
  })
});

mgr.events.addSilentRenewError(function () {
  console.error('Silent Renew Error：', arguments);
});

mgr.events.addUserSignedOut(function () {
  // alert('Going out!');
  // console.log('UserSignedOut：', arguments);  
  mgr.signoutRedirect().then(function (resp) {
    // console.log('signed out', resp);
  }).catch(function (err) {
    // console.log(err)
  })
});

export default class SecurityService {

  // process login response
  processLoginResponse () {
    return new Promise((resolve, reject) => {
      mgr.signinRedirectCallback().then(function(user, bb) {
          // console.log("signed in", user);
          return resolve(null)
      }).catch(function(err) {
          // console.log('Error completing auth code + pkce flow', err);
          return reject(err)
      });
    })
  }

  // Renew the token manually
  renewToken () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.signinSilent().then(function (user) {
        if (user == null) {
          self.signIn(null)
        } else{
          return resolve(user)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }

  // Get the user who is logged in
  getUser () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }

  // Check if there is any user logged in
  getSignedIn () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(false)
        } else{
          return resolve(true)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }

  // Redirect of the current window to the authorization endpoint.
  signIn () {
    mgr.signinRedirect().catch(function (err) {
      // console.log(err)
    })
  }
  
  // Redirect of the current window to the end session endpoint
  signOut () {    
    mgr.signoutRedirect().then(function (resp) {
      // console.log('signed out', resp);
    }).catch(function (err) {
      // console.log(err)
    })
  }

  // Get the profile of the user logged in
  getProfile () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.profile)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }

  // Get the token id
  getIdToken(){
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.id_token)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }

  // Get the session state
  getSessionState(){
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.session_state)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }

  // Get the access token of the logged in user
  getAccessToken(){
    let self = this
    // console.log('we are getting in') //for testing purposes
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.access_token)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }

  // Get the refresh token of the logged in user
  getRefreshToken(){
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.refresh_token)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }

  // Takes the scopes of the logged in user
  getScopes(){
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.scopes)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }

  // Get the user roles logged in
  getRole () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else{          
          return resolve(user.profile.role)
        }
      }).catch(function (err) {
        // console.log(err)
        return reject(err)
      });
    })
  }
}